import { fg } from '@atlaskit/platform-feature-flags/fg';
import { AnyAri, GoalSiteAri, ProjectSiteAri } from '@atlassian/ari';
// DEPRECATED: Use either `GoalSiteAri` or `ProjectSiteAri` instead.
// Moved to deep import becasue of depracated ARIs are not available in root.
import { TownsquareSiteAri } from '@atlassian/ari/townsquare';

const SITE_RESOURCE_TYPE = 'site';

type SiteAriType = typeof GoalSiteAri | typeof ProjectSiteAri | typeof TownsquareSiteAri;

const siteIdOf = (siteIdOrAri: string): string => {
	try {
		const ari = AnyAri.parse(siteIdOrAri);
		return ari.resourceType === SITE_RESOURCE_TYPE ? ari.resourceId : siteIdOrAri;
	} catch {
		return siteIdOrAri;
	}
};

const createSiteAri = (siteAriType: SiteAriType, siteId: string): string => {
	try {
		return siteAriType.create({ siteId }).toString();
	} catch {
		return '';
	}
};

const getAppSiteAri = (siteIdOrAri: string, siteAriType: SiteAriType): string => {
	const siteId = siteIdOf(siteIdOrAri);

	if (!fg('townsquare_goal_project_site_aris')) {
		// Pre-migration behaviour: site ARIs are passed through untouched, bare site ids
		// are turned into the deprecated townsquare-owned site ARI.
		return siteId === siteIdOrAri ? createSiteAri(TownsquareSiteAri, siteId) : siteIdOrAri;
	}

	return createSiteAri(siteAriType, siteId);
};

/**
 * Container ID for AGG `goals_*` fields, from either a site id or any site ari.
 * @returns The goal site ARI string, or empty string if creation fails
 */
export const getGoalSiteAri = (siteIdOrAri: string): string =>
	getAppSiteAri(siteIdOrAri, GoalSiteAri);

/**
 * Container ID for AGG `projects_*` fields, from either a site id or any site ari.
 * @returns The project site ARI string, or empty string if creation fails
 */
export const getProjectSiteAri = (siteIdOrAri: string): string =>
	getAppSiteAri(siteIdOrAri, ProjectSiteAri);
